import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_property_key } from "@swc/helpers/_/_to_property_key";
import { selectedServiceNames } from './serviceName';
const compact = (predicate)=>Object.keys(predicate).length === 0 ? undefined : predicate;
export const hasSetValues = (set)=>{
    var _ref, _ref1;
    var _set_in, _set_nin;
    return set != null && (((_ref = (_set_in = set.in) === null || _set_in === void 0 ? void 0 : _set_in.length) !== null && _ref !== void 0 ? _ref : 0) > 0 || ((_ref1 = (_set_nin = set.nin) === null || _set_nin === void 0 ? void 0 : _set_nin.length) !== null && _ref1 !== void 0 ? _ref1 : 0) > 0);
};
const nonEmptySet = (set)=>hasSetValues(set) ? set : undefined;
export const setToCheckboxes = (predicate)=>{
    var _predicate_in;
    return predicate.nin != null ? {
        selected: predicate.nin,
        operator: 'exclude'
    } : {
        selected: (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : [],
        operator: 'include'
    };
};
export const checkboxesToSet = (next)=>next.operator === 'exclude' ? {
        nin: [
            ...next.selected
        ]
    } : {
        in: [
            ...next.selected
        ]
    };
export const rebuildSetField = (predicate, field, value)=>{
    const { [field]: _omit } = predicate, rest = _object_without_properties(predicate, [
        _to_property_key(field)
    ]);
    const kept = nonEmptySet(value);
    return compact(kept == null ? rest : _object_spread_props(_object_spread({}, rest), {
        [field]: kept
    }));
};
export const rebuildDecimalField = (predicate, field, value)=>{
    const { [field]: _omit } = predicate, rest = _object_without_properties(predicate, [
        _to_property_key(field)
    ]);
    return compact(value == null ? rest : _object_spread_props(_object_spread({}, rest), {
        [field]: value
    }));
};
const buildDiscount = (type, amount)=>{
    const discount = {};
    if (type != null) discount.type = type;
    if (amount != null) discount.amount = amount;
    return Object.keys(discount).length === 0 ? undefined : discount;
};
const rebuildDiscount = (predicate, discount)=>{
    const { discount: _omit } = predicate, rest = _object_without_properties(predicate, [
        "discount"
    ]);
    return compact(discount == null ? rest : _object_spread_props(_object_spread({}, rest), {
        discount
    }));
};
export const rebuildDiscountType = (predicate, value)=>{
    var _predicate_discount;
    return rebuildDiscount(predicate, buildDiscount(nonEmptySet(value), (_predicate_discount = predicate.discount) === null || _predicate_discount === void 0 ? void 0 : _predicate_discount.amount));
};
export const rebuildDiscountAmount = (predicate, value)=>{
    var _predicate_discount;
    return rebuildDiscount(predicate, buildDiscount((_predicate_discount = predicate.discount) === null || _predicate_discount === void 0 ? void 0 : _predicate_discount.type, value));
};
const buildPriceIncrease = (exists, percent, startOnType)=>{
    const priceIncrease = {};
    if (exists != null) priceIncrease.exists = exists;
    if (percent != null) priceIncrease.percent = percent;
    if (startOnType != null) priceIncrease.startOnType = startOnType;
    return Object.keys(priceIncrease).length === 0 ? undefined : priceIncrease;
};
const rebuildPriceIncrease = (predicate, priceIncrease)=>{
    const { priceIncrease: _omit } = predicate, rest = _object_without_properties(predicate, [
        "priceIncrease"
    ]);
    return compact(priceIncrease == null ? rest : _object_spread_props(_object_spread({}, rest), {
        priceIncrease
    }));
};
export const rebuildPriceIncreasePercent = (predicate, value)=>{
    var _predicate_priceIncrease, _predicate_priceIncrease1;
    return rebuildPriceIncrease(predicate, buildPriceIncrease((_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.exists, value, (_predicate_priceIncrease1 = predicate.priceIncrease) === null || _predicate_priceIncrease1 === void 0 ? void 0 : _predicate_priceIncrease1.startOnType));
};
export const rebuildPriceIncreaseStartOnType = (predicate, value)=>{
    var _predicate_priceIncrease, _predicate_priceIncrease1;
    return rebuildPriceIncrease(predicate, buildPriceIncrease((_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.exists, (_predicate_priceIncrease1 = predicate.priceIncrease) === null || _predicate_priceIncrease1 === void 0 ? void 0 : _predicate_priceIncrease1.percent, nonEmptySet(value)));
};
export const rebuildPriceIncreaseExists = (predicate, value)=>{
    var _predicate_priceIncrease, _predicate_priceIncrease1;
    return rebuildPriceIncrease(predicate, buildPriceIncrease(value, (_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.percent, (_predicate_priceIncrease1 = predicate.priceIncrease) === null || _predicate_priceIncrease1 === void 0 ? void 0 : _predicate_priceIncrease1.startOnType));
};
export const rebuildLimitedTimeDiscount = (predicate, value)=>{
    const { limitedTimeDiscountOffer: _omit } = predicate, rest = _object_without_properties(predicate, [
        "limitedTimeDiscountOffer"
    ]);
    return compact(value == null ? rest : _object_spread_props(_object_spread({}, rest), {
        limitedTimeDiscountOffer: {
            exists: value
        }
    }));
};
const isNameOnlyArm = (arm)=>Object.keys(arm).length === 1 && arm.name != null;
const hasDiscountContent = (discount)=>discount != null && (hasSetValues(discount.type) || discount.amount != null);
const hasFlattenableContent = (predicate)=>{
    var _predicate_priceIncrease, _predicate_priceIncrease1, _predicate_limitedTimeDiscountOffer;
    return selectedServiceNames(predicate).length > 0 || hasSetValues(predicate.recurrence) || hasSetValues(predicate.billedUpon) || hasSetValues(predicate.pricingType) || predicate.priceMin != null || predicate.priceMax != null || predicate.cap != null || hasDiscountContent(predicate.discount) || ((_predicate_priceIncrease = predicate.priceIncrease) === null || _predicate_priceIncrease === void 0 ? void 0 : _predicate_priceIncrease.percent) != null || ((_predicate_priceIncrease1 = predicate.priceIncrease) === null || _predicate_priceIncrease1 === void 0 ? void 0 : _predicate_priceIncrease1.exists) != null || ((_predicate_limitedTimeDiscountOffer = predicate.limitedTimeDiscountOffer) === null || _predicate_limitedTimeDiscountOffer === void 0 ? void 0 : _predicate_limitedTimeDiscountOffer.exists) != null;
};
export const isFlattenableCondition = (predicate, quantifier)=>{
    var _predicate_or;
    if (quantifier !== 'any') return false;
    if (predicate.not != null) return false;
    const orArms = (_predicate_or = predicate.or) !== null && _predicate_or !== void 0 ? _predicate_or : [];
    if (orArms.some((arm)=>!isNameOnlyArm(arm))) return false;
    if (predicate.name != null && orArms.some((arm)=>arm.name != null)) return false;
    return hasFlattenableContent(predicate);
};
